import {Component, OnInit, Input, Inject, Injector, OnDestroy, ViewEncapsulation} from '@angular/core';
import { StepperService } from 'src/app/stepper.service';

import { SeaComponent } from '../sea.component';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import {
    SeaPriceDetailDialogComponent
} from "../../../components/sea-price-detail-dialog/sea-price-detail-dialog.component";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {
    TariffNotFoundDialogComponent
} from "../../../components/tariff-not-found-dialog/tariff-not-found-dialog.component";
import { AlternativeSegment } from 'src/app/models/alternative-segment';
import EntityUtil from 'src/app/shared/entity.util';
import { SseService } from 'src/app/services/sse-service';
import { SeaCalculatedFreightModel } from 'src/app/models/sea/sea-calculated-freight.model';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { ChangeDetectorRef } from '@angular/core';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
import { SeaPriceRequestDialogComponent } from 'src/app/components/sea-price-request-dialog/sea-price-request-dialog.component';
import { NgZone } from '@angular/core';
import { SeaPriceActionService } from 'src/app/services/sea/sea-price-action.service';
import { UserModel } from 'src/app/models/auth/user.model';

@Component({
  selector: 'app-price-request',
  templateUrl: './price-request.component.html',
  styleUrls: ['./price-request.component.scss']
})
export class SeaPriceRequestComponent extends BaseFormComponentComponent implements OnInit, OnDestroy {

  @Input("model") model: SeaModel;
  adminDialogRef: DynamicDialogRef;

  user: UserModel = null;
  requestComponent: SeaPriceRequestComponent = this;
  showAlternativeSegment: boolean = true;
  alternativeSegmentStartIndex: number = null;
  isDialogPriceOpen = false;
  showSpinner: boolean = false;

  tonnageSpinnerLimit = 2450;
  getPricedIntegrationProductSize: number = 0;
  aiHint: string = null;

  private messageSubscription: Subscription | null = null;


  viewType:string = 'list';
  constructor(
    protected injector: Injector, @Inject(SeaComponent) public parent: SeaComponent, private stepperService: StepperService,
    private seaSearchService: SeaSearchService, private sseService: SseService, private userService: UserService, private ngZone: NgZone,
    private cdr: ChangeDetectorRef, private searchLogHistoryService: SearchLogClickHistoryService, private priceActionService: SeaPriceActionService) {
    super(injector)
    this.parent.isLoading = true;

  }



  ngOnInit(): void {
    if(this.messageSubscription) {
      this.messageSubscription.unsubscribe();
      this.messageSubscription = null;
    }

    this.tonnageSpinnerLimit = this.model.service == 'ATA' ? 25101: 24500;

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      console.warn("Mobil/Tablet görünümü aktif");
      this.viewType = "card";
    }

    window.matchMedia("(max-width: 768px)").addEventListener('change', e => {
      this.viewType = e.matches ? "card" : "table";
    });

    // if(window.innerWidth <= 768) {
    //   console.log("card view e girdi")
    //   this.viewType = "card";
    // }
      this.parent.isConfirmation = false;
      if (this.model?.products){
        this.showSpinner = this.model.products.filter(product => product.hasIntegration).length > 0
      }


      // tonaj limiti aşılırsa mükerrer gelen fiyat talep ürünlerini benzersiz yap.
      // TODO backend'den mükerrer gelen online ürünlerin nedenini anla ve  benzersiz olmasını sağla.
      if(this.model && this.model.products) {
        if(this.tonnageSpinnerLimit >= this.model.tonnage) {
            let onlineProducts = this.model.products.filter(f => f.hasNoOnlinePrice);
            let tariffProducts = this.model.products.filter(f => !f.hasNoOnlinePrice);
            const uniqueProducts = Array.from(new Map(onlineProducts.map(item => [item.id, item])).values());
            this.model.products =  [...tariffProducts, ...uniqueProducts];
            this.cdr.detectChanges();
          }
      }
  

      if(this.model.selectedProduct && this.parent.showOnlyComponent) {
      this.model.selectedProduct.isSelectedFromList = true;
      if (this.model?.products){
        this.model.products = [this.model.selectedProduct].concat(this.model.products).filter(product => {
            return (!product?.isOverLimit && !product?.freights?.errorCode) || product?.isSelectedFromList;
        });
        this.model.products = this.model.products.filter((x, i, a) => a.indexOf(x) == i);
      }else {
        this.model.products = [];
        this.model.products = [this.model.selectedProduct].concat(this.model.products).filter(product => {
            return (!product?.isOverLimit && !product?.freights?.errorCode) || product?.isSelectedFromList;
        });
        this.model.products = this.model.products.filter((x, i, a) => a.indexOf(x) == i);
      }
    }

    if(this.parent?.stepper?.notShowReservation) this.parent.stepper.notShowReservation = this.onlyShowPriceRequests();

    if (!this.messageSubscription) { 
      
      this.messageSubscription =   this.sseService.getMessages().subscribe(message => {
        if (message === 'Search process completed.') {
          this.sseService.disconnect();
          this.messageSubscription.unsubscribe();
          this.showSpinner = false;
       
          

          // Online fiyat bulunmayan ürünler fiyat talep et olarak aktif edilir.
          let onlineProductsUniqueById = Array.from(new Map(this.model.products.map(item => [item.id, item])).values()).filter(f => f.hasIntegration);
          if(onlineProductsUniqueById) {

            onlineProductsUniqueById.forEach(p => {
              let foundOnlineProductWithPrice = this.model.products.find(_p => _p.id == p.id && _p?.freights?.unitPrice && _p?.freights?.unitPrice > 0);
              if(!foundOnlineProductWithPrice) {
                 let newProduct = { ...p }; 
                  newProduct.hasIntegration = false;
                  newProduct.hasNoOnlinePrice = true;
                  this.model.products = [...this.model.products, newProduct];
                  this.sseService.onChangeProduct.next(newProduct);
                  this.cdr.detectChanges();
              }
            })

            this.getAiHint();
            
          }
         
           
        
          return;
        }
        if(this.model.isNoPrice) return;
        
        let price = JSON.parse(message) as SeaCalculatedFreightModel;
        let product = this.model.products.find(f => f.uuid == price.uuid);
        if(product) { 
          let newProduct = { ...product }; 
          if(price.grandTotal) {
            newProduct.hasIntegration = false;
            newProduct.isCompleteOnlinePrice = true;
            newProduct.freights = price;
            newProduct.uuid = price.newProductUuid;
            newProduct.hasOnlinePrice = true;
            newProduct.frontTariff = price.frontTariff;
            newProduct.endTariff = price.endTariff;
            newProduct.freights.availableTonnage = this.model.service == 'ATA' ? 25100: 24500;
           
            if(product.dueDates && product.dueDates.length > 0) {
             const maxPercent =  product.dueDates.reduce(
                (max, current) => (current.percent > max.percent ? current : max),
                product.dueDates[0]
              );
              newProduct.selectedDue = maxPercent
            }
            this.model.products = [...this.model.products, newProduct];


            this.cdr.detectChanges();
           
            this.sseService.onChangeProduct.next(newProduct);
          }
        }
  
      })
    }

    if(!this.showSpinner) {
      this.getAiHint();
    }

    this.sseService.setReady();
    
   }
   
   
   async makeReservation(selectedProduct: MarketSeaProductsModel = null, marketProductsDefId = null, productId = null, uuid = null, products = null) {

    this.user = await this.userService.user().toPromise();
    const approveMessage = await this.translation.get('approveMessageLabel').toPromise();
    if(this.user.status != 'AP') {
        this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: approveMessage});
        return;
    }
      
    this.isLoading = true;  
    if(selectedProduct) this.model.marketProductsDefId = selectedProduct.marketProductsDefId;
    if(!selectedProduct) this.model.marketProductsDefId = marketProductsDefId;
    this.model.selectedProduct = selectedProduct;
    this.model.requestUuid = uuid;

    if (!selectedProduct && marketProductsDefId){
        this.model.newPriceProduct = productId;
    }

    try {
      if(!this.model.selectedProduct ||  !this.model.selectedProduct.isSelectedFromList) {
        if(products && products.length > 0) {
          let quotoNo = [];
          for (let index = 0; index < products.length; index++) {
            const product = products[index];
            this.model.marketProductsDefId = product.marketProductsDefId;
            this.model.requestUuid = product.uuid;
            this.model.quoteNo = null;
            this.model = await this.seaSearchService.offer(this.model).toPromise();
            quotoNo.push(this.model.quoteNo);
          }
            this.isLoading = false;
            this.parent.reservationInfoLoading = true;
            window.scroll({top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth'});
            this.parent.container.clear();
            this.model.quoteNo = quotoNo.join(",");
            this.parent.model = this.model;

            this.stepperService.changeCurrentStep(3);
            this.parent.renderStepComponent(this.parent.stepComponents[3], this.model, 3);

            if(!this.parent.showOnlyComponent) {
            this.addQueryParam("page", "REZ")
            }

        } else {
          this.model = await this.seaSearchService.offer(this.model).toPromise();
          // todo sonra düzenlecek. test için yapıldı.
          this.isLoading = false;
          this.parent.reservationInfoLoading = true;
          window.scroll({top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth'});
          this.parent.container.clear();
          this.parent.model = this.model;

          this.stepperService.changeCurrentStep(3);
          this.parent.renderStepComponent(this.parent.stepComponents[3], this.model, 3);

          if(!this.parent.showOnlyComponent) {
          this.addQueryParam("page", "REZ")
          }

        }
       
      } else {
        this.model = await  this.seaSearchService.insurance(this.model).toPromise();

          this.isLoading = false;
          this.parent.reservationInfoLoading = true;
          window.scroll({top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth'});
          this.parent.container.clear();
          this.parent.model = this.model;

          this.stepperService.changeCurrentStep(3);
          this.parent.renderStepComponent(this.parent.stepComponents[3], this.model, 3);

          if(!this.parent.showOnlyComponent) {
          this.addQueryParam("page", "REZ")
          }

      }

       
    } catch(error) {
        this.model.selectedProduct = null;
        // zaman aşımına uğrayan bir istek gerçekleşti ise bir önceki adıma geri dönüyoruz.
        if (error == 'searchTimeOut') {
            this.parent.container.clear();
            this.stepperService.changeCurrentStep(1);
            window.scroll({ top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth' });
        }

        this.isLoading = false;
        this.parent.reservationInfoLoading = false;
        this.parent.isLoading = false;
    }


  }

    async priceInfo(product: MarketSeaProductsModel) {
      await this.priceActionService.openPriceInfo(product, this.model, this);
        
    }
    async priceRequest(product: MarketSeaProductsModel) {

        this.isDialogPriceOpen = true;

        this.ngZone.run(() => {
            this.adminDialogRef = this.dialogService.open(SeaPriceRequestDialogComponent, { header: null, showHeader: false, modal: true, width: '1000px', height: 'auto', closable: false, data: { product: product, model: this.model, parentComponent: this, showButton: true } });
        })

        this.adminDialogRef.onClose.subscribe((data) => {
          this.isDialogPriceOpen = false;
          if(data && data.products) {
            this.makeReservation(null, null, null, null, data?.products).then(r => {})
          }
        });
        
    }


    ngOnDestroy() {
        if (this.adminDialogRef) {
            this.adminDialogRef.close();
        }
        this.unsubscribeFromMessages();
    }

    private unsubscribeFromMessages(): void {
      if (this.messageSubscription) {
        this.messageSubscription.unsubscribe();
        this.messageSubscription = null;
      }
    }

    calculateTeu() {

       return  this.model?.containerType?.name.startsWith('2') ? this.model?.containerCount : this.model?.containerCount * 2;
    }

    isPrice(){
      return document.getElementById('price_newprice_btn') !== null;
    }

    frontTariffNotFound(){
        this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "front"}});
    }
    endTariffNotFound(){
        this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, {  header: null,  showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "end"}});
    }
    frontEndTariffNotFound(){
        this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, {  header: null,  showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "frontend"}});
    }
    onlyShowPriceRequests() {
        if(this.model.isNoPrice) return false;
        if(!this.model.products) return true;


        const noPriceProductsSize = this.model.products.filter(product => ((product?.isOverLimit && !product?.isSelectedFromList) || product?.freights?.errorCode))

        if(noPriceProductsSize.length == this.model.products.length) return true;

        return false;

      }
      onSelectViewType(viewType:string) {
        this.viewType = viewType;
        this.createClickHistory(viewType);
      }

      createClickHistory(viewType: string) {
        const model = new SearchLogClickHistoryModel();
        model.viewType = this.mapViewType(viewType);
        model.searchLogId = this.model?.id || null;

        this.searchLogHistoryService.create(model).toPromise();
      }

      private mapViewType(type: string): string {
        switch (type) {
          case 'card': return 'CARDVIEW';
          case 'list': return 'LISTVIEW';
          case 'calendar': return 'CALENDERVIEW';
          default: return type.toUpperCase();
        }
      }


      async onShowAlternative() {
        
        const user = await this.userService.user().toPromise();
        
        if(this.model.isNoPrice || user.status != 'AP') {
          this.showMessage('warn', 'alternativeSegmentProfileMessage');
          return;
        }

        this.isLoading = true;
        let clonedModal = Object.assign({}, this.model);
        let fromPortAlternativeSegments: AlternativeSegment[] = [];
        let toPortAlternativeSegments: AlternativeSegment[] = [];

        this.alternativeSegmentStartIndex = this.model.products.length -1

        let alternativeProducts: MarketSeaProductsModel[] = [];

        this.model.alternativeSegments.forEach(f => {
          if((f.toType == 'NFO' || f.toType == 'NFO') && !this.hasPriceProduct()) {
            if(f.fromOrTo == 'to' && f.toSeaPort) toPortAlternativeSegments.push(f);
            if(f.fromOrTo == 'from' && f.fromSeaPort) fromPortAlternativeSegments.push(f);
          }

          if(f.toType == 'ALL' || f.fromType == 'ALL') {
            if(f.fromOrTo == 'to' && f.toSeaPort) toPortAlternativeSegments.push(f);
            if(f.fromOrTo == 'from' && f.fromSeaPort) fromPortAlternativeSegments.push(f);
          }
        })

        for (let id = 0; id < fromPortAlternativeSegments.length; id++) {
          const fp = fromPortAlternativeSegments[id];
          const segment = await this.seaSearchService.segment(fp.fromSeaPort.id, this.model.arrivalPort.id, this.model.departureCountry.id, this.model.arrivalCountry.id).toPromise();
          if(segment) {
            clonedModal.segment = segment;
            clonedModal.products = [];
            clonedModal.departurePort = EntityUtil.toSeaportMinDTO(fp.fromSeaPort);
            const resp = await this.seaSearchService.search(clonedModal).toPromise();

            resp.products.map(s => {
              s.isAlternativeSegment = true; 
              // s.alternativeSegmentPortName = `${fp.portName} - ${this.model.arrivalPort?.name}`;
              s.alternativeSegmentPortName = `${segment.name}`;
              s.description = fp.description;
              s.descriptionEn = fp.descriptionEn;
              s.alternativeArrivalPort = resp.arrivalPort?.name;
              s.alternativeDeparturePort = resp.departurePort?.name;
            });
            const hasPriceProducts = resp.products.filter(p => !p.freights.errorCode && p.freights.grandTotal);
            alternativeProducts = alternativeProducts.concat(hasPriceProducts);
          }
        }
        
             
        for (let id = 0; id < toPortAlternativeSegments.length; id++) {
          const tp = toPortAlternativeSegments[id];
          const segment = await this.seaSearchService.segment(this.model.departurePort.id, tp.toSeaPort.id, this.model.departureCountry.id, this.model.arrivalCountry.id).toPromise();
          if(segment) {
            clonedModal.segment = segment;
            clonedModal.products = [];
            clonedModal.arrivalPort = EntityUtil.toMinDTO(tp.toSeaPort);
            const resp = await this.seaSearchService.search(clonedModal).toPromise();

            resp.products.map(s => {
              s.isAlternativeSegment = true; 
               s.alternativeSegmentPortName = `${segment.name}`;
              // s.alternativeSegmentPortName = `${this.model.departurePort?.name} - ${tp.portName}`;
              s.description = tp.description; s.descriptionEn = tp.descriptionEn;
              s.alternativeArrivalPort = resp.arrivalPort?.name;
              s.alternativeDeparturePort = resp.departurePort?.name;
            });
            const hasPriceProducts = resp.products.filter(p => !p.freights.errorCode && p.freights.grandTotal);
            alternativeProducts = alternativeProducts.concat(hasPriceProducts);
          }
        }

        if(!alternativeProducts || (alternativeProducts && alternativeProducts.length == 0)) {
          this.showMessage('warn', 'noProductAlternativeSegment');

        } else {
          this.model.products = this.model.products.concat(alternativeProducts);
        }

        
       

        this.isLoading = false;
        this.showAlternativeSegment = false;

      
        
      }

      public hasPriceProduct() {
        if(!this.model.products) return false;
        if(this.model.products.length == 0) return false;
         return this.model.products.find(s => s?.freights.grandTotal && !s?.freights.errorCode)  ? true : false;
     }
            
     public getAiHint() {
      return;
        let user = this.userService.getLocale();
        if (user && ['weld-int.com', 'weld.com', 'xinerji.com', 'dff-tech.com'].includes(user.email.split('@')[1])) {
          if(this.model.products && this.model.products.length > 0) {
            this.seaSearchService.getAiHint(this.mapToProductsAiRequest()).toPromise().then(r => {
              this.aiHint = r; 
            })
          }
        }
      }
      public mapToProductsAiRequest() {

        const aiHintReqModel = {
          fromCity: this.model?.departureCity?.name,
          toCity: this.model?.arrivalCity?.name,
          products: []
        }
        
        
        debugger;
       const products =  this.model.products.reduce((acc, product) => {
          const f = product.freights;

          debugger;
          if (f && f.unitPrice != null) {
            debugger;
            
            acc.push({
              etd: f.etd,
              eta: f.eta,
              cutOffDate: f.cutOffDate,
              grandTotal: f.grandTotal,
              shipOwner: (f.shipOwner || product.shipOwner),
              shipInfo: f.shipInfo,
              uuid: (f.uuid || product.uuid),
              viaPortDTOList: f.viaPortDTOList || [] 
            });
          }

          return acc;
        }, [] as any[]);

        aiHintReqModel.products = products;

        console.log(this.model.products, aiHintReqModel);

   
        return aiHintReqModel;
      }

      
}
